import RenderManager from "sap/ui/core/RenderManager";
import Camera from "./Camera";

export default {
  apiVersion: 2,

  render: function (rm: RenderManager, control: Camera) {
    rm.openStart("div", control);
    rm.openEnd();
    rm.openStart("video", control);
    rm.attr("autoplay", true);
    rm.attr("playsinline", true);
    rm.openEnd();
    rm.close("video");
    rm.openStart("canvas");
    rm.style("display", "none");
    rm.openEnd();
    rm.close("canvas");
    rm.close("div");
  },
};
